import { FilterTypes } from '@/Domain/enum';

const filters = [
    {
        type: FilterTypes.INPUT,
        label: 'lang.listManagement.search',
        param: ['fullName', 'nif'],
        icon: 'fa-search'
    }
];

export default filters;
